import { render, staticRenderFns } from "./bookingDetail.vue?vue&type=template&id=4ee472b2&scoped=true"
import script from "./bookingDetail.vue?vue&type=script&lang=js"
export * from "./bookingDetail.vue?vue&type=script&lang=js"
import style0 from "./bookingDetail.vue?vue&type=style&index=0&id=4ee472b2&prod&lang=scss&scoped=true"
import style1 from "./bookingDetail.vue?vue&type=style&index=1&id=4ee472b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee472b2",
  null
  
)

export default component.exports